import AssignmentIcon from '@mui/icons-material/Assignment';
import ShareIcon from '@mui/icons-material/Share'; // Assuming you still want to use the ShareIcon for the second icon
import { Box, Typography } from '@mui/material';
import {getFile} from "../../../../../api/customer/files.api";
import {getCartesetPDF} from "../../../../../api/customer/documents.api";
import {parseJSON} from "date-fns";

const KartesetTitleComponent = ({ label, user, setDisplayedData,id ,range}) => {
    const currentYear = new Date().getFullYear(); // Get the current year

    // Handlers for the icons
    const handleAssignmentClick = () => {
        console.log('Assignment Icon Clicked');
    };

    const handleShareClick = () => {
        getFile(false, () => getCartesetPDF(parseJSON(range[0]!), parseJSON(range[1]!), id), 'כרטסת', undefined, undefined, undefined);
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', padding: '5px 5px 0px 45px' }}>
            <Box
                sx={{
                    display: 'flex',
                    maxHeight: '50px',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}
            >
                <Typography
                    sx={{
                        display: 'flex',
                        fontSize: '15px',
                        fontWeight: 'bold',
                        color: 'black',
                        lineHeight: '15px',
                        flexGrow: 1
                    }}
                >
                    כרטסת לשנה - {currentYear}
                </Typography>
                <Box sx={{ display: 'flex', gap: '10px' }}>
                    <AssignmentIcon onClick={handleAssignmentClick} style={{ cursor: 'pointer' }} />
                    <ShareIcon onClick={handleShareClick} style={{ cursor: 'pointer' }} />
                </Box>
            </Box>
            לקוח: בדיקה
        </Box>
    );
};

export default KartesetTitleComponent;
